import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useRouteParams } from '../hooks/useRouteParams';
import { toast } from '../../CommonComponents/OPL/Toast/Toast';
import { queryKeys } from './queryKeys';

export interface FidelityAvailableUserDTO {
  id: string;
  name: string;
}

const fetchFidelityAvailableUserList = ({ clientId }): Promise<FidelityAvailableUserDTO[]> => {
  return authFetch(
    urlWithParams('/Consumer/DocumentVault/GetFidelityAvailableUsersList', {
      clientId,
    }),
  );
};

export const useFidelityAvailableUsersListQuery = () => {
  const { clientId } = useRouteParams();

  return useQuery(
    queryKeys.fidelityAvailableUsersList(clientId),

    () => fetchFidelityAvailableUserList({ clientId }),

    {
      onError: () => {
        toast.error('Sorry, something went wrong. Please try again.');
      },
    },
  );
};
